
import React from "react";
import Cookies from "universal-cookie";
import { Wordpress } from "../functions/Woocommerce";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

var cookies_element = {};

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username_error: true,
      error_message: "",
      loading: false,
    };
    this.submitSignInApiAsync = this.submitSignInApiAsync.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  async submitSignInApiAsync(event) {
    event.preventDefault();
    this.setState({ loading: true, error_message: "" });

    const cookies = new Cookies();

    try {
      const res = await Wordpress.authenticate(cookies_element);

      if (res.data && res.data.token) {
        const token = res.data.token;

        cookies.set("token", token);
        localStorage.setItem("token", token);

        console.log("✅ Token:", token);
        this.props.history.push("/pos");
      } else {
        this.setState({
          username_error: true,
          error_message: "❌ Login failed — no token returned from server.",
          loading: false,
        });
      }
    } catch (error) {
      const response =
        error?.response?.data?.message ||
        error?.response?.data?.error_description ||
        error?.message ||
        "❌ Network or unknown error occurred.";

      console.error("Login error:", error.response || error.message);

      this.setState({
        username_error: true,
        error_message: response,
        loading: false,
      });
    }
  }

  handleChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    cookies_element[name] = value;
  }

  render() {
    return (
      <div>
        <div className="wrapper fadeInDown">
          <div id="formContent">
            <div className="fadeIn first">
              <img
                src="https://www.muktaofficial.com/wp-content/uploads/2020/07/MUKTA-logo.png"
                id="icon"
                alt="User Icon"
              />
            </div>
            <form>
              {this.state.username_error && this.state.error_message && (
                <div className="text-danger">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.error_message,
                    }}
                  />
                </div>
              )}
              <input
                type="text"
                id="login"
                className="fadeIn second"
                name="username"
                placeholder="Login"
                onChange={this.handleChange}
              />

              <input
                type="password"
                id="password"
                className="fadeIn third"
                name="password"
                placeholder="Password"
                onChange={this.handleChange}
              />

              <Button
                variant="fadeIn fourth login"
                onClick={this.submitSignInApiAsync}
              >
                {this.state.loading ? (
                  <>
                    Signing ...
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  </>
                ) : (
                  "Sign In"
                )}
              </Button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
